var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      attrs: { id: "contact-button" },
      on: {
        click: function ($event) {
          return _vm.contactButton()
        },
      },
    },
    [_c("img", { attrs: { src: "/img/icons/envelope.svg" } })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }